import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PigmyPageModal from '../../components/PigmyPageModal';
import { useAuth } from "../../authentication/AuthContext";
function PigmyDeposit() {
  const [data, setData] = useState({ heading: '', paragraphs: [] });
    const { isAuthenticated } = useAuth();
  const fetchData = () => {
    // Directly call the fixed route '/api/pigmy-deposit'
    axios.get(`/api/pigmy-deposit`)
      .then(res => {
        setData(res.data || {});
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchData();
  }, []);  // This fetches the data once when the component is mounted.

  return (
    <div className='body'>
      <div className='heading'>
        {data.heading || "PIGMY/DAILY DEPOSIT"}
  {isAuthenticated  && ( 
        <PigmyPageModal /> 
           )} 
      </div>
      <hr />
      <hr />
      <div className='body bordered_box' style={{whiteSpace:"pre-line"}}>
        {(data.paragraphs || []).map((p, i) => (
          <p key={i} style={{whiteSpace:"pre-line"}}>{p}</p>
        ))}
      </div>
    </div>
  );
}

export default PigmyDeposit;
